<template>
  <div>
    <b-container class=" pb-4">
      <nav-title :title="'About'" />

      <b-row class="mt-3 mb-0 mx-0 py-2 border-bottom bg-light">
        <b-col cols="12">
          <b-card-text>
            <div v-html="getAboutUs" class="py-3 container px-lg-5"></div>
          </b-card-text>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import navTitle from "@/components/general/navTitle.vue";
import store from "@/store";
import { mapGetters } from "vuex";
export default {
  components: {
    navTitle
  },
  computed: {
    ...mapGetters("general", ["getAboutUs"])
  },
  beforeRouteEnter(to, from, next) {
    Promise.all([store.dispatch("general/downloadAboutUs")]).then(() => {
      next();
    });
  }
};
</script>

<style scoped>
.bg-congrats {
  background-image: url("../../assets/bg-congrats.png");
  background-size: contain;
}
.bg-congrats .bg-white {
  height: 570px;
}
.bg-coin {
  background-image: url("../../assets/icons/icon-money-star.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  color: #f6a724;
}
.bg-coin p {
  font-size: 4.5em;
  padding-top: 21%;
  padding-bottom: 21%;
}
.icon-star-medium {
  width: 3.5em;
}
.text-full {
  font-size: 5em;
}
</style>
